import React from 'react';

export default function Download() {
  return (
    <div className="space-y-10 py-6">
      {/* Header */}
      <section className="text-center">
        <h1 className="mc-title text-mc-emerald text-2xl md:text-3xl mb-3">🔌 Descarga el Plugin</h1>
        <p className="text-mc-muted max-w-lg mx-auto">
          Instala el plugin de OnStats en tu servidor MCDR y empieza a registrar las estadísticas de minería de tus jugadores.
        </p>
      </section>

      {/* Steps */}
      <section className="grid grid-cols-1 md:grid-cols-3 gap-6">
        <div className="mc-border rounded-xl p-5 bg-mc-card text-center">
          <div className="text-3xl mb-3">📥</div>
          <h3 className="text-mc-gold font-bold mb-2">1. Descarga</h3>
          <p className="text-mc-muted text-sm">
            Descarga <span className="text-mc-accent">OnStats.py</span> y colócalo en la carpeta <span className="text-mc-text font-mono text-xs bg-mc-darker px-1 rounded">plugins/</span> de tu servidor MCDR.
          </p>
        </div>

        <div className="mc-border rounded-xl p-5 bg-mc-card text-center">
          <div className="text-3xl mb-3">🔑</div>
          <h3 className="text-mc-gold font-bold mb-2">2. Configura el Token</h3>
          <p className="text-mc-muted text-sm mb-2">
            Solicita tu token de API y configúralo:
          </p>
          <code className="text-mc-accent text-xs bg-mc-darker px-2 py-1 rounded block">
            !!onstats set token &lt;tu-token&gt;
          </code>
        </div>

        <div className="mc-border rounded-xl p-5 bg-mc-card text-center">
          <div className="text-3xl mb-3">👥</div>
          <h3 className="text-mc-gold font-bold mb-2">3. Agrega Jugadores</h3>
          <p className="text-mc-muted text-sm mb-2">
            Registra los jugadores a trackear:
          </p>
          <code className="text-mc-accent text-xs bg-mc-darker px-2 py-1 rounded block">
            !!onstats add &lt;username&gt;
          </code>
        </div>
      </section>

      {/* Commands */}
      <section className="mc-border rounded-xl p-6 bg-mc-card">
        <h2 className="text-mc-diamond font-bold mb-4 text-center mc-title text-lg">📋 Comandos Disponibles</h2>
        <div className="space-y-2 max-w-lg mx-auto">
          <div className="flex justify-between items-center py-2 border-b border-mc-border/30">
            <code className="text-mc-accent text-xs">!!onstats add &lt;user&gt;</code>
            <span className="text-mc-muted text-xs">Agrega un jugador</span>
          </div>
          <div className="flex justify-between items-center py-2 border-b border-mc-border/30">
            <code className="text-mc-accent text-xs">!!onstats del &lt;user&gt;</code>
            <span className="text-mc-muted text-xs">Elimina un jugador</span>
          </div>
          <div className="flex justify-between items-center py-2 border-b border-mc-border/30">
            <code className="text-mc-accent text-xs">!!onstats list</code>
            <span className="text-mc-muted text-xs">Lista jugadores registrados</span>
          </div>
          <div className="flex justify-between items-center py-2 border-b border-mc-border/30">
            <code className="text-mc-accent text-xs">!!onstats update</code>
            <span className="text-mc-muted text-xs">Envía estadísticas al backend</span>
          </div>
          <div className="flex justify-between items-center py-2">
            <code className="text-mc-accent text-xs">!!onstats set token &lt;t&gt;</code>
            <span className="text-mc-muted text-xs">Configura token de API</span>
          </div>
        </div>
      </section>

      {/* How it works */}
      <section className="mc-border rounded-xl p-6 bg-mc-card">
        <h2 className="text-mc-gold font-bold mb-4 text-center mc-title text-lg">🔄 ¿Cómo funciona?</h2>
        <div className="space-y-3 max-w-lg mx-auto text-mc-muted text-sm">
          <p>1. Al ejecutar <code className="text-mc-accent">!!onstats update</code>, el plugin ejecuta <code className="text-mc-accent">save-all</code> en el servidor.</p>
          <p>2. Lee los archivos de estadísticas de cada jugador y suma los bloques minados.</p>
          <p>3. Envía los datos al backend, que almacena un snapshot con la fecha actual.</p>
          <p>4. Los datos se reflejan en el portal web con gráficos de progreso.</p>
        </div>
      </section>

      {/* Requirements + Download */}
      <section className="text-center space-y-6">
        <p className="text-mc-muted text-sm">
          <span className="text-mc-text font-bold">Requisitos:</span> MCDReforged 2.x+ · <a href="https://mcdreforged.com/en/plugin/stats_helper/introduction" target="_blank" rel="noopener noreferrer" className="text-mc-accent hover:underline">Stats Helper</a> · Python 3.8+ · requests
        </p>
        <a
          href="https://github.com/yerepf/onstats-plugin"
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center gap-2 px-8 py-4 bg-mc-emerald text-mc-darker font-bold rounded-xl hover:bg-mc-emerald/90 transition-colors text-lg"
        >
          <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24"><path d="M12 0c-6.626 0-12 5.373-12 12 0 5.302 3.438 9.8 8.207 11.387.599.111.793-.261.793-.577v-2.234c-3.338.726-4.033-1.416-4.033-1.416-.546-1.387-1.333-1.756-1.333-1.756-1.089-.745.083-.729.083-.729 1.205.084 1.839 1.237 1.839 1.237 1.07 1.834 2.807 1.304 3.492.997.107-.775.418-1.305.762-1.604-2.665-.305-5.467-1.334-5.467-5.931 0-1.311.469-2.381 1.236-3.221-.124-.303-.535-1.524.117-3.176 0 0 1.008-.322 3.301 1.23.957-.266 1.983-.399 3.003-.404 1.02.005 2.047.138 3.006.404 2.291-1.552 3.297-1.23 3.297-1.23.653 1.653.242 2.874.118 3.176.77.84 1.235 1.911 1.235 3.221 0 4.609-2.807 5.624-5.479 5.921.43.372.823 1.102.823 2.222v3.293c0 .319.192.694.801.576 4.765-1.589 8.199-6.086 8.199-11.386 0-6.627-5.373-12-12-12z"/></svg>
          Descargar Plugin
        </a>
      </section>
    </div>
  );
}
